<template>
    <div>
        <h1 class="mdn-Heading mdn-Heading--sm">Formulários adoção</h1>

        <SGPBotaoAdicionarNovoComponent @sgpAdiconarNovoEmit="adicionarNovo" />

        <SGPPaginacaoComponent :paginacao="paginacao" v-if="listaFormularios.length"
            @sgpAtualizarPaginacao="realizarPaginacao" :key="paginacao">
            <SGPTabelaComponent :colunas="colunas" :dados="listaFormularios"
                @sgpTabelaLinhasSelecionadasEmit="gerenciadorDeSelecionados"
                @sgpTabelaEditarSelecionadoEmit="editarSelecionado"
                @sgpTabelaDeletarSelecionadoEmit="deletarSelecionado" @sgpTabelaModalCadastrarEmit="abrirPrevisualizar"
                :filtroText="true"></SGPTabelaComponent>
        </SGPPaginacaoComponent>

        <SGPAlertaComponent v-else></SGPAlertaComponent>

        <SGPModalComponent v-if="abrirModal" tamanho="lg" titulo="Formulário" @sgpModalFechar="fecharModal"
            :mostrarFooter="false">
            <FormularioFormComponent :tipoFormulario="tipoFormulario" :formDinamico="formDinamico" />
        </SGPModalComponent>

        <SGPConfirmacaoDelecaoComponent v-if="deletarDados" @sgpCancelarDelecaoEmit="cancelarDelecao()"
            @sgpConfirmarDelecaoEmit="confirmarDelecao()" />

        <SGPModalComponent v-if="abrirModalPrevisualizar" tamanho="lg" titulo="Formulário adoção"
            @sgpModalFechar="fecharPrevisualizar" :mostrarFooter="false">
            <RenderizaFormularioComponent v-if="formularioSelecionadoId" :key="formularioSelecionadoId"
                :formulario_id="formularioSelecionadoId" @dadosFormularioDinamicoEmit="dadosFormulario" />
        </SGPModalComponent>

        <SGPLoadingComponent v-if="loadingFormularios" />
    </div>

</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import FormularioFormComponent from '../components/FormularioFormComponent.vue'
import RenderizaFormularioComponent from '../components/RenderizaFormularioComponent'

const modulo = 'portalAdocao';
export default {
    components: { FormularioFormComponent, RenderizaFormularioComponent },
    name: 'ListaFormulariosPage',

    data() {
        return {
            formulariosSelecionados: [],
            formularioSelecionado: {},
            tipoFormulario: 'salvar',
            formDinamico: {},
            abrirModal: false,
            deletarDados: false,
            abrirModalPrevisualizar: false,
            formularioSelecionadoId: ''

        }
    },

    async created() {
        await this.paginarFormularios(modulo);
    },


    computed: {
        ...mapGetters('formularios', ['listaDeFormularios', 'loadingFormularios']),

        colunas() {
            return [
                {
                    key: 'selecionar',
                    label: '',
                    sortable: false
                },
                {
                    key: 'titulo',
                    label: 'Formulário',
                    sortable: false
                },
                {
                    key: 'acl_modulos.modulo',
                    label: 'Módulo',
                    sortable: false
                },
                {
                    key: 'modalGenerica',
                    label: 'Visualizar',
                    sortable: false
                }
            ]
        },

        listaFormularios() {
            if (!this.listaDeFormularios.data) return []
            return this.listaDeFormularios.data.map(form => {
                if (!form.acl_modulos) { form.acl_modulos = { 'modulo': '-' } }
                return form
            })
        },

        paginacao() {
            if (!this.listaDeFormularios.data) return {}

            let totalRegistro = this.listaDeFormularios.total

            if (this.listaDeFormularios.data.length > this.listaDeFormularios.per_page) {
                totalRegistro++
            } else if (this.listaDeFormularios.data.length > this.listaDeFormularios.total) {
                totalRegistro = this.listaDeFormularios.data.length
            } else {
                if (this.listaDeFormularios.current_page > 1) {
                    let currPage = this.listaDeFormularios.current_page - 1
                    let totalReg = (this.listaDeFormularios.per_page * currPage) + this.listaDeFormularios.data.length
                    if (totalReg > this.listaDeFormularios.total)
                        totalRegistro = totalReg
                }
            }

            const paginate = {
                per_page: this.listaDeFormularios.per_page,
                total: totalRegistro,
                current_page: this.listaDeFormularios.current_page
            }

            return {
                per_page: paginate.per_page >= paginate.total ? paginate.total : paginate.per_page,
                total: paginate.total,
                current_page: paginate.current_page
            }
        }
    },

    methods: {
        ...mapActions('formularios', ['paginarFormularios', 'excluirFormularios', 'filtrarListarFormularios']),

        gerenciadorDeSelecionados(selecionados) {
            this.formulariosSelecionados = selecionados
        },

        editarSelecionado() {
            this.tipoFormulario = 'editar';
            this.formDinamico = this.formulariosSelecionados[0];
            this.abrirModal = true;
        },

        deletarSelecionado() {
            this.deletarDados = true;
        },

        cancelarDelecao() {
            this.deletarDados = false;
        },

        confirmarDelecao() {
            this.excluirFormularios(this.formulariosSelecionados);
            this.deletarDados = false;
        },

        adicionarNovo() {
            this.formDinamico = {};
            this.tipoFormulario = 'salvar';
            this.abrirModal = true;
        },

        fecharModal() {
            this.abrirModal = false;
        },

        abrirPrevisualizar(formulario) {
            this.abrirModalPrevisualizar = true;
            this.formularioSelecionadoId = formulario.id;
        },

        fecharPrevisualizar() {
            this.abrirModalPrevisualizar = false;
            this.formularioSelecionadoId = '';
        },

        async realizarPaginacao(paginacao) {
            let payload = {
                ...paginacao,
                modulo
            }
            await this.filtrarListarFormularios(payload)
        },
    }
}
</script>
